/**
 * RowSeverIcon — the one "cut a tie" affordance for relationship-list rows
 * (§8, 2026-06-16, Pedro). Always visible, like the section "+ Add" button:
 *   - Read mode  → greyed + disabled, tooltip "Enter Edit mode to detach".
 *   - Edit mode  → red + enabled, tooltip = stageLabel; click stages the sever.
 *   - Staged     → undo-arrow (gray), click un-stages.
 *   - Deleted row→ nothing (the link is already gone).
 *
 * Mirrors the Agreement Accounts-tab detach icon. Centralising it keeps every
 * relationship list consistent by construction (the behaviour has been tuned
 * several times — one place to change it).
 */
import { ActionIcon, Tooltip } from '@mantine/core';
import { IconArrowBackUp, IconUnlink } from '@tabler/icons-react';

interface Props {
  pending: boolean;
  editMode: boolean;
  deleted: boolean;
  onStage: () => void;
  onUnstage: () => void;
  /** Tooltip for the enabled action, e.g. "Detach this party (on Save)". */
  stageLabel: string;
}

export function RowSeverIcon({
  pending, editMode, deleted, onStage, onUnstage, stageLabel,
}: Props) {
  if (pending) {
    return (
      <Tooltip label="Undo staged detach" withArrow>
        <ActionIcon size="sm" variant="subtle" color="gray" onClick={onUnstage}>
          <IconArrowBackUp size={14} />
        </ActionIcon>
      </Tooltip>
    );
  }
  if (deleted) return null;
  return (
    <Tooltip label={editMode ? stageLabel : 'Enter Edit mode to detach'} withArrow>
      <span style={{ display: 'inline-block' }}>
        <ActionIcon size="sm" variant="subtle" color="red" disabled={!editMode} onClick={onStage}>
          <IconUnlink size={14} />
        </ActionIcon>
      </span>
    </Tooltip>
  );
}
